import React from 'react';

export default (props) => {

    return (
        <React.Fragment>
            <props.Component {...props} />
        </React.Fragment>
    );
}